// The end of a tab switch's wait for the gateways response of the new tab. It
// lives apart from the other actions because both the tab switch and
// fetchGateways use it, and the tab switch module is loaded by `./index`.
//
// The wait starts with RESET_TAB_STATE, the first thing a switch dispatches.

// The wait ended: the gateways response arrived (or failed), or it is clear
// that no gateways request can follow the switch.
export const tabSwitchGatewaysSettled = () => ({ type: 'TAB_SWITCH_GATEWAYS_SETTLED' });
